export const config = {
  bnsfUrl: "https://bnsf.railpermitting.com",
  cpUrl: "https://app.railpermitting.com",
  tcwrUrl: "https://tcwr.railpermitting.com",
}
